import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';
import {
  LOCATION_EQUIPMENT_LIST,
  LOCATION_EQUIPMENT_REFRESH,
  LOCATION_EQUIPMENT_REFRESH_ALL,
  LOCATION_EQUIPMENT_RESTART,
  LOCATION_EQUIPMENT_RESTART_ALL,
  SET_SELECTED_LOCATION,
  SET_SELECTED_LOCATION_EQUIPMENT,
  START_POLLING,
  STOP_POLLING,
} from './type';

export const setSelectedEquipment = createAction(
  SET_SELECTED_LOCATION_EQUIPMENT
);
export const setSelectedLocation = createAction(SET_SELECTED_LOCATION);
export const getLocationEquipments = createRoutine(LOCATION_EQUIPMENT_LIST);
export const refreshLocationEquipments = createRoutine(
  LOCATION_EQUIPMENT_REFRESH
);
export const refreshAllLocationEquipments = createRoutine(
  LOCATION_EQUIPMENT_REFRESH_ALL
);
export const restartLocationEquipments = createRoutine(
  LOCATION_EQUIPMENT_RESTART
);
export const restartAllLocationEquipments = createRoutine(
  LOCATION_EQUIPMENT_RESTART_ALL
);
export const startPolling = createRoutine(START_POLLING);
export const stopPolling = createRoutine(STOP_POLLING);
